import { SVGProps, Ref, forwardRef } from 'react';

export const ENSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={4} width={32} height={24} rx={4} fill="#22408C" />
            <path
                d="M12.16 10.12 4 4A4 4 0 0 0 .106 7.08l6.774 5.08H0v7.68h6.88L.106 24.92A4 4 0 0 0 4 28l8.16-6.12V28h7.68v-6.12L28 28a4 4 0 0 0 3.894-3.08l-6.774-5.08H32v-7.68h-6.88l6.774-5.08A4 4 0 0 0 28 4l-8.16 6.12V4h-7.68z"
                fill="#EEEEEE"
            />
            <path d="m30.775 5.119-9.388 7.041H19.84v-1.24l9.084-6.813a4 4 0 0 1 1.85 1.012" fill="#CF1B2B" />
            <path d="m.317 6.437 7.63 5.723h3.2L1.469 4.902A4 4 0 0 0 .317 6.437" fill="#CF1B2B" />
            <path d="M12.16 19.84v1.24l-9.084 6.813a4 4 0 0 1-1.85-1.012l9.387-7.041z" fill="#CF1B2B" />
            <path d="M30.53 27.098a4 4 0 0 0 1.153-1.535l-7.63-5.723h-3.2z" fill="#CF1B2B" />
            <path d="M18.4 18.4V28h-4.8v-9.6H0v-4.8h13.6V4h4.8v9.6H32v4.8z" fill="#CF1B2B" />
        </g>
    </svg>
));
ENSize32Glyph.displayName = 'ENSize32Glyph';
